import { useState } from 'react';

import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from '@mui/material';
import { Button, Modal } from 'react-bootstrap';
import {useTranslation} from "react-i18next";

const Filter = ({
  show,
  onHide,
  filterInputs,
  filterInputsUpdate,
  initialState,
  setFilter,
  setSkip,
  navigate,
}) => {
  const [isExpired, setIsExpired] = useState(
    filterInputs.isExpired === '' ? 'all' : false
  );
  const [openIsExpired, setOpenIsExpired] = useState(false);

  const {t} = useTranslation();

  function handleChange(event, handlerFunc) {
    const value = event.target.value;
    handlerFunc(value);
    filterInputsUpdate(event);
    setSkip(0);
  }
  return (
    <>
      <Modal
        size="md"
        show={show}
        onHide={() => onHide(false)}
        aria-labelledby="create"
        centered
        className="modal-right pr-0"
      >
        <Modal.Header closeButton>
          <Modal.Title id="create">{t("CIRCULATION_FILTER")}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="col-12 pl-4 pr-4">
            <div className="row">
              <div className="col-12 col-md-12 col-lg-12">
                <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                  <TextField
                    id="code"
                    name="code"
                    label={t("CIRCULATION_NUMBER")}
                    placeholder={t("CIRCULATION_NUMBER")}
                    className="w-100"
                    value={filterInputs.code}
                    onChange={(e) => filterInputsUpdate(e)}
                  />
                </div>
              </div>
              <div className="col-12 col-md-12 col-lg-12">
                <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                  <InputLabel htmlFor="expiredDate">
                    {t("BET_STOP_DATE")}
                  </InputLabel>
                  <TextField
                    type="date"
                    id="expiredDate"
                    name="expiredDate"
                    className="w-100"
                    value={filterInputs.expiredDate}
                    onChange={(e) => filterInputsUpdate(e)}
                  />
                </div>
              </div>
              <div className="col-12 col-md-12 col-lg-12">
                <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                  <InputLabel htmlFor="resultedDate">
                    {t("CIRCULATION_STOP_DATE")}
                  </InputLabel>
                  <TextField
                    type="date"
                    id="resultedDate"
                    name="resultedDate"
                    className="w-100"
                    value={filterInputs.resultedDate}
                    onChange={(e) => filterInputsUpdate(e)}
                  />
                </div>
              </div>
              <div className="col-12 col-md-12 col-lg-12">
                <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                  <TextField
                    id="productName"
                    name="productName"
                    label={t("PRODUCT_NAME")}
                    placeholder={t("PRODUCT_NAME")}
                    className="w-100"
                    value={filterInputs.productName}
                    onChange={(e) => filterInputsUpdate(e)}
                  />
                </div>
              </div>
              <div className="col-12 col-md-12 col-lg-12">
                <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                  <TextField
                    id="totalAmount"
                    name="totalAmount"
                    label={t("POOL_AMOUNT")}
                    placeholder={t("POOL_AMOUNT")}
                    className="w-100"
                    value={filterInputs.totalAmount}
                    onChange={(e) => filterInputsUpdate(e)}
                  />
                </div>
              </div>
              <div className="col-12 col-md-12 col-lg-12">
                <div className="w-100 pt-2 pb-3 d-flex flex-wrap">
                  <FormControl className="w-100">
                    <InputLabel id="isExpired">{t("FINISHED")}/{t("ACTIVE")}</InputLabel>
                    <Select
                      label={`${t("FINISHED")}/${t("ACTIVE")}}`}
                      labelId="isExpired"
                      open={openIsExpired}
                      onClose={() => setOpenIsExpired(false)}
                      onOpen={() => setOpenIsExpired(true)}
                      value={isExpired}
                      onChange={(e) => handleChange(e, setIsExpired)}
                      inputProps={{
                        name: 'isExpired',
                        id: 'isExpired',
                      }}
                    >
                      <MenuItem value="all">{t("ALL")}</MenuItem>
                      <MenuItem value="true">{t("FINISHED")}</MenuItem>
                      <MenuItem value="false">{t("ACTIVE")}</MenuItem>
                    </Select>
                  </FormControl>
                </div>
              </div>
              <div className="col-12 col-md-12 col-lg-12">
                <div
                  style={{ gap: '12px' }}
                  className="w-100 pt-2 pb-3 d-flex justify-content-center"
                >
                  <Button
                    className="w-100"
                    variant="success"
                    onClick={() => onHide(false)}
                  >
                    {t("APPLY")}
                  </Button>

                  <Button
                    className="w-100"
                    variant="danger"
                    onClick={() => {
                      navigate(`/circulations?skip=0&take=10`);
                      setFilter(initialState);
                      setIsExpired('all');
                    }}
                  >
                    {t("CLEAR")}
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default Filter;
